import { useId } from 'react';
import { COLOR_TEXT_PRIMARY_INVERSE } from '@alltrails/denali/tokens';

type LinkedInProps = {
  className?: string;
  openInNewTab?: boolean;
  color?: string;
  noFollowSocials?: boolean;
};

export default function LinkedInIcon({ className = '', openInNewTab = false, color = COLOR_TEXT_PRIMARY_INVERSE, noFollowSocials }: LinkedInProps) {
  const titleId = useId();
  return (
    <a
      href="https://www.linkedin.com/company/alltrails"
      target={openInNewTab ? '_blank' : '_self'}
      rel={`noreferrer${noFollowSocials ? ' nofollow' : ''}`}
      className={className}
      data-testid="linkedin-icon"
    >
      <svg role="img" aria-labelledby={titleId} xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
        <title id={titleId}>LinkedIn</title>
        <g fill="none" fillRule="evenodd">
          <g fill={color} fillRule="nonzero">
            <g>
              <g>
                <path
                  d="M125.5 2.583c7.122 0 12.917 5.795 12.917 12.917s-5.795 12.917-12.917 12.917-12.917-5.795-12.917-12.917S118.378 2.583 125.5 2.583zm0-2.583C116.94 0 110 6.94 110 15.5c0 8.56 6.94 15.5 15.5 15.5 8.56 0 15.5-6.94 15.5-15.5C141 6.94 134.06 0 125.5 0zm-2.583 10.333c0 .72-.578 1.302-1.292 1.302-.714 0-1.292-.58-1.292-1.302 0-.72.578-1.302 1.292-1.302.714 0 1.292.584 1.292 1.302zm0 2.584h-2.584v7.75h2.584v-7.75zm3.875 0h-2.584v7.75h2.584V16.97c0-2.224 2.586-2.43 2.586 0v3.696h2.58v-4.339c0-4.242-4.04-4.087-5.166-2v-1.411z"
                  transform="translate(-126 -590) translate(16 561) translate(0 29)"
                />
              </g>
            </g>
          </g>
        </g>
      </svg>
    </a>
  );
}
